import api from './api';

export const authService = {
  login: (credentials) => api.login(credentials.email, credentials.password),
  register: (userData) => api.register(userData),
  googleLogin: (idToken) => api.googleLogin(idToken),
  forgotPassword: (email) => api.forgotPassword(email),
  resetPassword: (token, password) => api.resetPassword(token, password),
  getProfile: () => api.getProfile(),
  getCurrentUser: () => api.getProfile(), // Alias for getProfile
  updateProfile: (userData) => api.put('/auth/profile', userData),
  verifyToken: () => api.getProfile(), // Use getProfile to verify token
  logout: () => {
    api.setToken(null);
    return Promise.resolve();
  }
};

export default authService;